import React from 'react';
import Icon from '../../../components/AppIcon';

/**
 * PLACEHOLDER CONTENT — these are illustrative, not collected from real users.
 * There is no reviews API in the backend yet, so nothing here is verifiable.
 * Replace with genuine, attributable testimonials (with permission) before
 * relying on this section publicly; presenting invented reviews as real is
 * both misleading and, for consumer marketplaces in India and elsewhere,
 * a regulatory risk.
 */
const testimonials = [
  {
    name: 'Priya Sharma',
    role: 'Tenant',
    city: 'Mumbai',
    rating: 5,
    text: 'Found a 2BHK in Andheri within a week. The owner was verified and the entire process was transparent. Saved ₹25,000 in brokerage!',
  },
  {
    name: 'Ananya Reddy',
    role: 'Tenant',
    city: 'Bangalore',
    rating: 4,
    text: 'As a working woman moving to a new city, safety was my priority. The verified listings and direct owner contact gave me confidence.',
  },
  {
    name: 'Sneha Patil',
    role: 'Tenant',
    city: 'Pune',
    rating: 4,
    text: 'Shifted to Pune for my job. Found a great PG near my office through the app. The filter options are really helpful.',
  },
];

const initials = (name) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join('');

const Stars = ({ rating }) => (
  <div className="flex items-center gap-1" aria-label={`${rating} out of 5 stars`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Icon
        key={i}
        name="Star"
        size={18}
        aria-hidden="true"
        className={i < rating ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}
      />
    ))}
  </div>
);

const TenantTestimonials = () => {
  return (
    <section className="py-14 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-14">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 tracking-tight">
            What Our Tenants Say
          </h2>
          <p className="text-gray-500 mt-3 text-base sm:text-lg">
            Join thousands of happy tenants who found their perfect home with us
          </p>
        </div>

        <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t) => (
            <li
              key={t.name}
              className="flex flex-col rounded-2xl bg-white border border-gray-100 p-7 shadow-[0_4px_24px_-12px_rgba(17,24,39,0.12)] hover:shadow-[0_8px_32px_-12px_rgba(17,24,39,0.16)] transition"
            >
              <Icon name="Quote" size={34} className="text-rose-500 shrink-0" aria-hidden="true" />

              <div className="mt-4">
                <Stars rating={t.rating} />
              </div>

              {/* blockquote grows so the author row stays bottom-aligned across cards */}
              <blockquote className="mt-4 flex-1 text-[15px] text-gray-600 leading-relaxed">
                {t.text}
              </blockquote>

              <figcaption className="flex items-center gap-3 mt-6">
                <span
                  className="w-12 h-12 rounded-full bg-rose-500 text-white text-sm font-semibold flex items-center justify-center shrink-0"
                  aria-hidden="true"
                >
                  {initials(t.name)}
                </span>
                <span className="leading-tight">
                  <span className="block font-semibold text-gray-900">{t.name}</span>
                  <span className="block text-sm text-gray-500">{t.role}</span>
                  <span className="block text-sm text-gray-500">{t.city}</span>
                </span>
              </figcaption>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TenantTestimonials;
